import api from '../api'; // your Axios instance



export async function getInternational() {
    return api.get('/dashboard/international/fetch');
}

export async function updateInternational(formData: FormData) {
    return api.post('/dashboard/international/update', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export async function getInternationalTeam() {
    return api.get('/dashboard/international/team');
}

export async function addInternationalTeam(formData: FormData) {
    return api.post('/dashboard/international/team/create', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    })
}

export async function fetchSingleTeam(id: number) {
    return api.get(`/dashboard/international/team/${id}`);
}

export async function updateTeam(id: number, formData: FormData) {
    return api.post(`/dashboard/international/team/${id}/update`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    })
}

export async function deleteTeam(id: number) {
    return api.post(`/dashboard/international/team/${id}/delete`);
}

export async function getInternationalBrands() {
    return api.get('/dashboard/international/brands');
}

export async function addInternationalBrand(formData: FormData) {
    return api.post('/dashboard/international/brands/add',
        formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
}

export async function deleteInternationalBrand(id: number) {
    return api.post(`/dashboard/international/brands/${id}/delete`);
}

export async function fetchSingleBrand(id: number) {
    return api.get(`dashboard/international/brands/${id}/fetch`);
}

export async function updateInternationalBrand( id: number, formData: FormData) {
    return api.post(`/dashboard/international/brands/${id}/update`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    })
}

export async function getInternationalBrandProducts(id: number) {
    return api.get(`/dashboard/international/brands/${id}/products`);
}

export async function addInternationalProduct(formData: FormData, id: number) {
    return api.post(`/dashboard/international/brand/${id}/products/create`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    })
}

export async function fetchIndividualProduct(id: number) {
    return api.get(`/dashboard/international/products/${id}/fetch`);
}

export async function updateInternationalProduct(formData: FormData, id: number) {
    return api.post(`/dashboard/international/products/${id}/update`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    })
}

export async function deleteInternationalProduct(id: number) {
    return api.post(`/dashboard/international/products/${id}/delete`)
}
